import React, { createContext, useContext, useState, useEffect } from "react";

interface PublicCatalogContextType {
    isPublicView: boolean,
    setIsPublicView: (val: boolean)=>void,
    uuid: string,
    setUuid: (val:string)=>void
}


const PublicCatalogContext = createContext<PublicCatalogContextType | undefined>(undefined);


export const PublicCatalogProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [isPublicView, setIsPublicView] = useState<boolean>(false)
    const [uuid, setUuid] = useState<string>("false")

    return (
        <PublicCatalogContext.Provider value={{ isPublicView, setIsPublicView, uuid, setUuid}}>
        {children}
        </PublicCatalogContext.Provider>
    );
};

export const usePublicCatalog = () => {
    const context = useContext(PublicCatalogContext);
    if (!context) throw new Error("usePublicCatalog must be used within a PublicCatalogProvider");
    return context;
};